import { render, staticRenderFns } from "./interviewMaterial.vue?vue&type=template&id=333b3fa2&scoped=true"
import script from "./interviewMaterial.vue?vue&type=script&lang=js"
export * from "./interviewMaterial.vue?vue&type=script&lang=js"
import style0 from "./interviewMaterial.vue?vue&type=style&index=0&id=333b3fa2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b3fa2",
  null
  
)

export default component.exports